import type { FC, JSX } from "react";
import React from "react";

import { Counter } from "../../../../Counter/Counter";

import type { CounterProps } from "../../../../Counter/Counter";

const TAG_COUNTER_TEST_ID = "tag-counter-test-id";

interface ITagCounterMain extends Pick<CounterProps, "size"> {}

interface ITagCounter {}

export const TagCounter: FC<ITagCounter> = (props): JSX.Element => {
    const { ...restProps } = props as ITagCounter & ITagCounterMain;

    return (
        <Counter
            {...(restProps as CounterProps)}
            view="custom"
            /** Переменные прилетают от родителя */
            customColorsStyles=""
            data-tsid={TAG_COUNTER_TEST_ID}
        />
    );
};

TagCounter.displayName = "Tag.Counter";

export default TagCounter;
